const GAS_BRAND_MERCHANT_STATUSES = {
  active: { name: "active", id: "active" },
  blocked: { name: "blocked", id: "blocked" },
  disabled: { name: "disabled", id: "disabled" },
};

export default GAS_BRAND_MERCHANT_STATUSES;
